import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupUnion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBooleanGroupUnion"><Path d="M18.25 2.75H11.75C10.0931 2.75 8.75 4.09315 8.75 5.75V8.75H5.75C4.09315 8.75 2.75 10.0931 2.75 11.75V18.25C2.75 19.9069 4.09315 21.25 5.75 21.25H12.25C13.9069 21.25 15.25 19.9069 15.25 18.25V15.25H18.25C19.9069 15.25 21.25 13.9069 21.25 12.25V5.75C21.25 4.09315 19.9069 2.75 18.25 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBooleanGroupUnion;
